import AppHeader from '../app-header/AppHeader'
import LegalFooter from '../legal-footer/LegalFooter'

import { PageRoot, ContentRegion, ContentWidthLimiter } from './styled'
import { AppLayoutProps } from './types'

/**
 * Page shell for signed-in surfaces. Renders the cream gradient
 * background, the header with navigation, and centres the children
 * inside a width-limited content region.
 *
 * The legal footer sits outside the width limiter so it stays centred on the
 * page rather than on the content column, and is part of the shell rather than
 * any one page so that the privacy policy is reachable from everywhere the
 * renter can get to.
 *
 * @param {AppLayoutProps} props
 * @returns {JSX.Element}
 */
const AppLayout = ({
  children,
  showNavigation = true,
  contentMaxWidth = 'standard',
}: AppLayoutProps): JSX.Element => {
  return (
    <PageRoot>
      <AppHeader showNavigation={showNavigation} />
      <ContentRegion>
        <ContentWidthLimiter contentMaxWidth={contentMaxWidth}>
          {children}
        </ContentWidthLimiter>
      </ContentRegion>
      <LegalFooter />
    </PageRoot>
  )
}

export default AppLayout
